import { render, staticRenderFns } from "./TopicBlock.vue?vue&type=template&id=384c0d32&scoped=true&"
import script from "./TopicBlock.vue?vue&type=script&lang=js&"
export * from "./TopicBlock.vue?vue&type=script&lang=js&"
import style0 from "./TopicBlock.vue?vue&type=style&index=0&id=384c0d32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c0d32",
  null
  
)

export default component.exports